// extracted by mini-css-extract-plugin
export default {"submitButton":"DuSignup_submitButton__2a1P0"};